<template>
  <div>
    <FilterToolbarWithSearchBy
      :hasChanges="hasChanges"
      :appliedFilters="appliedFilters"
      @search="search"
      allowSearchBy
      :searchByOptions="searchByOptions"
      @update="update"
      @clear="clear">
      <remote-facet-filter
        class="border-b"
        v-model="connectionFacetValue"
        response-type="object"
        :resourceLabel="(context.isSupplier()) ? 'retailer.name' : 'brand.name'"
        :resourceValue="(context.isSupplier()) ? 'retailer.id' : 'brand.id'"
        :filter="filterOptions.connection"
        :endpoint="context.route + '/connections/?short=1'"
        @input="change"
      />
      <facet-filter
        class="border-b"
        v-model="filters.facets.status"
        :filter="filterOptions.status"
        @input="change"
      />
      <facet-filter
        v-if="context.isSupplier()"
        class="border-b"
        v-model="filters.facets.reason_id"
        :filter="filterOptions.supplierReasons"
        @input="change"
      />
      <facet-filter
        v-if="context.isMerchant()"
        class="border-b"
        v-model="filters.facets.reason_id"
        :filter="filterOptions.merchantReasons"
        @input="change"
      />
      <boolean-filter
        class="border-b"
        v-model="filters.facets.is_acknowledged"
        :filter="filterOptions.acknowledged"
        @input="change"
      />
      <date-filter
        v-model="filters.timestamps.created_at"
        :filter="filterOptions.createdAt"
        @input="change"
      />
    </FilterToolbarWithSearchBy>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as filterOptions from '../../filters/rmas.js'
import FilterToolbarWithSearchBy from '@/components/Filters/FilterToolbarWithSearchBy'
import BooleanFilter from '@/components/Filters/BooleanFilter'
import DateFilter from '@/components/Filters/DateFilter'
import FacetFilter from '@/components/Filters/FacetFilter'
import RemoteFacetFilter from '@/components/Filters/RemoteFacetFilter'

export default {
  components: {
    BooleanFilter,
    DateFilter,
    FacetFilter,
    FilterToolbarWithSearchBy,
    RemoteFacetFilter
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      // filters
      filterOptions: filterOptions,
      searchByOptions: [
        {
          value: 'customer_order_number',
          label: 'Customer Order #'
        }, {
          value: 'purchase_order_number',
          label: 'Purchase Order #'
        }, {
          value: 'retailer_order_number',
          label: 'Retailer Order #'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['context']),
    connectionFacetKey () {
      return this.context.isSupplier() ? 'retailer_id' : 'brand_id'
    },
    connectionFacetValue: {
      get () {
        return (this.filters && this.filters.facets) ? this.filters.facets[this.connectionFacetKey] : undefined
      },
      set (value) {
        this.$set(this.filters.facets, this.connectionFacetKey, value)
      }
    }
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchByParameter, searchQuery) {
      this.filters.search = {
        parameter: searchByParameter,
        query: searchQuery
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  mounted () {

  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
